import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import createWebStorage from "redux-persist/lib/storage/createWebStorage";
import appReducer from "./slices/app.slice";
import estimationReducer from "./slices/estimation.slice";
import userReducer from "./slices/user.slice";
// ----------------------------------------------------------------------

const createNoopStorage = () => ({
  getItem() {
    return Promise.resolve(null);
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setItem(_key: string, value: any) {
    return Promise.resolve(value);
  },
  removeItem() {
    return Promise.resolve();
  },
});

const storage = typeof window !== "undefined" ? createWebStorage("local") : createNoopStorage();

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const appPersistConfig = {
  key: "app",
  storage,
  keyPrefix: "redux-",
  blacklist: ["loading"],
};

const userPersistConfig = {
  key: "user",
  storage,
  keyPrefix: "redux-",
};

const rootReducer = combineReducers({
  app: persistReducer(appPersistConfig, appReducer),
  user: persistReducer(userPersistConfig, userReducer),
  estimation: estimationReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export { rootPersistConfig, rootReducer };
